"use client";
import React from "react";
import {
  Center,
  Separator,
  Table,
  Box,
  Flex,
  Text,
  VStack,
  Stack,
  HStack,
  SimpleGrid,
} from "@chakra-ui/react";
import { Heading } from "@/elements";
import { useHeadingVariant } from "@/theme/hooks/useSectionStyle";
import PricingFooter from "@/components/pricingFooter";
import { ISV_DESKTOP_DATA, FOOTER_CONSTANTS, FOOTER_NOTE } from "./constants";

export const DesktopView = () => {
  return (
    <Table.Root striped border={"2px solid rgb(237,242,247)"} width={"100%"}>
      <Table.Header>
        <Table.Row>
          <Table.ColumnHeader>CPU</Table.ColumnHeader>
          <Table.ColumnHeader>Memory</Table.ColumnHeader>
          <Table.ColumnHeader>Base Clock | Boost</Table.ColumnHeader>
          <Table.ColumnHeader>Disk</Table.ColumnHeader>
          <Table.ColumnHeader>GPU</Table.ColumnHeader>
          <Table.ColumnHeader>Pricing (Linux)</Table.ColumnHeader>
        </Table.Row>
      </Table.Header>

      <Table.Body>
        {ISV_DESKTOP_DATA.map((plan, index) => (
          <Table.Row
            key={index}
            style={{ whiteSpace: "nowrap" }}
            fontSize={"15px"}
            color="#2d3748"
          >
            <Table.Cell>
              <Box
                display={"flex"}
                alignItems={"center"}
                flexDirection={"row"}
                gap={"6px"}
              >
                <Flex direction={"column"} style={{ whiteSpace: "nowrap" }}>
                  <Box>{plan.processor}</Box>
                  <Box style={{ fontSize: "12px", color: "text.100" }}>{plan.sku}</Box>
                </Flex>
              </Box>
            </Table.Cell>
            <Table.Cell style={{ whiteSpace: "nowrap" }}>{plan.memory}</Table.Cell>
            <Table.Cell>{plan.basecock_boost}</Table.Cell>
            <Table.Cell>{plan.disk}</Table.Cell>
            <Table.Cell>{plan.gpu}</Table.Cell>
            <Table.Cell>
              <Text fontWeight={"700"} fontSize={"18px"} color="primary.200">
                {plan.price}
              </Text>
            </Table.Cell>
          </Table.Row>
        ))}
      </Table.Body>
    </Table.Root>
  );
};

export const MobileView = () => {
  return (
    <SimpleGrid columns={{ base: 1, sm: 2 }} gap={6}>
      {ISV_DESKTOP_DATA.map((plan, index) => (
        <VStack
          key={index}
          borderRadius="lg"
          borderWidth="1px"
          borderColor="gray.200"
          boxShadow="md"
          gap={4}
          w="100%"
          p={4}
          bg="white"
        >
          <HStack gap={3} align="center" w="full">
            <Flex flex="1" direction="column">
              <Text fontWeight="bold" fontSize="lg">
                {plan.processor}
              </Text>
              <Text fontSize="sm" color="text.100">
                {plan.sku}
              </Text>
            </Flex>
          </HStack>

          <Separator borderColor="gray.200" />

          <HStack justify="center" w="full">
            <Text fontSize="sm" color="text.100">
              GPU
            </Text>
            <Text fontWeight="medium" fontSize="md">
              {plan.gpu}
            </Text>
          </HStack>

          <Stack direction="row" gap={4} justify="space-between" w="full" flexWrap="wrap">
            <Flex direction="column" flex="1">
              <Text fontSize="sm" color="text.100">
                Memory
              </Text>
              <Text fontWeight="medium" fontSize="md">
                {plan.memory}
              </Text>
            </Flex>
            <Flex direction="column" flex="1">
              <Text fontSize="sm" color="text.100">
                Disk
              </Text>
              <Text fontWeight="medium" fontSize="md">
                {plan.disk}
              </Text>
            </Flex>
          </Stack>

          <Stack direction="row" gap={4} justify="space-between" w="full" flexWrap="wrap">
            <Flex direction="column" flex="1">
              <Text fontSize="sm" color="gray.600">
                Base Clock | Boost
              </Text>
              <Text fontWeight="semibold" fontSize="md">
                {plan.basecock_boost}
              </Text>
            </Flex>
            <Flex direction="column" flex="1">
              <Text fontSize="sm" color="text.100">
                Price
              </Text>
              <Text fontWeight="bold" fontSize="lg" color="primary.200">
                {plan.price}
              </Text>
            </Flex>
          </Stack>
        </VStack>
      ))}
    </SimpleGrid>
  );
};

const ISVDesktopTable = () => {
  const HeadingVariant = useHeadingVariant();
  return (
    <Box id="isv-desktops">
      <Heading variant={HeadingVariant} textAlign={"center"} mb={8}>
        ISV Desktops
      </Heading>
      <Center display={{ md: "none" }} w="full">
        <MobileView />
      </Center>
      <Box display={{ base: "none", md: "block" }}>
        <DesktopView />
      </Box>
      <Box textAlign={"center"} my={4}>
        <Text as="span" color="text.100" fontWeight={600}>
          NOTE :{" "}
        </Text>
        <Text as="span" color="text.100" textAlign={"center"}>
          {FOOTER_NOTE}
        </Text>
      </Box>
      <PricingFooter {...FOOTER_CONSTANTS} />
      <Separator borderWidth="2px" borderColor="#ECECEC" my={10} />
    </Box>
  );
};

export default ISVDesktopTable;
